import React, { useEffect } from 'react';


const PoliticsComercialBikeUS = () => {


    const discountData = [
        { from: "$0.00", to: "$9,999.00", discount: "0%" },
        { from: "$10,000.00", to: "$29,999.00", discount: "2%" },
        { from: "$30,000.00", to: "$59,999.00", discount: "4%" },
        { from: "$60,000.00", to: "$99,999.00", discount: "6%" },
        { from: "$100,000.00", to: "$299,999.00", discount: "8%" },
        { from: "$300,000.00", to: ">", discount: "12%" },
    ];

    return (
        <>
            <section className="fale-conosco container">
                <div className="sect-header">
                    <div className="sect-titulo">
                        <h1>COMMERCIAL POLICY</h1>
                    </div>
                    <hr />
                </div>
                <div className="subtitulo-politics">
                    <h4>OBJECTIVE</h4>
                    This document aims to establish the basic rules of Shimano Mexico to define the
                    commercialization strategy. This policy is fundamental for the correct functioning of the company since the
                    commercial results will depend directly on it.
                </div>

                <div className="subtitulo-politics">
                    <span>1. Payment terms (period):</span><br /><br />
                    The history that each client has had with the Shimano brand will be taken as a basis. The payment terms are as
                    follows:
                    <ul>
                        <li><b> Cash Payment:</b> This term applies to new clients and those who do not have a credit history with
                            the brand.</li>
                        <li><b>30 days:</b> Based on the account's history, a minimum period of three months will be taken and an evaluation will be performed to
                            determine if they are eligible for a thirty-day financing.</li>
                    </ul>

                    Clients with 30 and 60-day terms will receive a 1% bonus for early payment via an electronic wallet which
                    will be reflected in their account statement and which can be applied to any order the client decides. <br /><br />

                    Additionally, clients who have a 30 or 60-day credit and choose to pay for their order in cash, will have an
                    <b> additional 2% discount</b> which will be applied directly to their order.<br /><br />

                    Clients with delayed payments on their invoices will enter a period of account freezing for their next
                    orders, once 100% of the total due is received, the account will be reactivated. Additionally, as of the 1st day of
                    delay, a fine equivalent to 5% monthly (prorated) of the total debt will be applied. In the same way, their credit
                    limit will be decreased by 50% and they must wait a period of 3 months to be able to access their initial credit limit. If
                    the delay is greater than 8 weeks, 100% of the credit limit will be lost and the client will be changed to a cash scheme.
                </div>

                <div className="subtitulo-politics">
                    <span>2. Credit limit:</span><br /><br />
                    Without exception, all clients with the right to a term must be previously documented with a promissory note that legally
                    backs the value of their credit. Clients interested in increasing their credit limit will have to show a minimum
                    history of 3 months of timely payments to be able to access a 20% increase on their
                    current credit amount. Ideally, the client should present proof of credit limit with other suppliers and
                    if possible, their financial statements as support. All credit increases must be approved by Shimano
                    Mexico and in some cases the increase may not apply if the company decides so.
                </div>

                <div className="subtitulo-politics">
                    <span>3. Wallets:</span><br /><br />
                    Clients with a credit line. Once the invoice is paid before its due date, a 1%
                    bonus will be obtained in an electronic wallet which will have a validity period of 12 months after its issuance.
                </div>

                <div className="subtitulo-politics">
                    <span>4. Distribution channels:
                    </span><br /><br />
                    The established distribution channels are those listed below. For strategic reasons, selling to other channels
                    that are not listed is not allowed:
                    <ul>
                        <li><b>Boutique Stores:</b> Stores that are characterized by handling a very high-end lineup. They are generally
                            characterized by commercializing one or two bicycle brands.</li>
                        <li><b>IBDs:</b> Multi-brand cycling stores on their sales floors.</li>
                        <li><b>Wholesalers:</b> Clients who have logistical tools for their own distribution, reaching points of
                            sale and locations that are not yet strategically part of Shimano Mexico's distribution channel.</li>
                        <li><b>OEM:</b> Clients who have a bicycle assembly operation within the country.</li>
                        <li><b>Cycling Workshops:</b> Establishments specialized in bicycle maintenance or repair.</li>
                    </ul>
                </div>

                <div className="subtitulo-politics">
                    <span>5. Discounts:</span><br /><br />
                    Shimano Mexico will have quarterly billing reviews for discount adjustments based on the history that will be
                    determined in the monthly average.
                    <br /><br />

                    <b>However, for strategic reasons, 4 discount ranges will be managed based on purchase history</b><br /><br />

                    <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th colSpan="3" style={{ ...thStyle, textAlign: 'center', backgroundColor: '#e0e0e0' }}>
                                        DISCOUNT BASED ON MONTHLY PURCHASE AVERAGE
                                    </th>
                                </tr>
                                <tr>
                                    <th style={thStyle}>FROM</th>
                                    <th style={thStyle}>TO</th>
                                    <th style={thStyle}>% DISCOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {discountData.map((row, index) => (
                                    <tr key={index}>
                                        <td style={tdStyle}>{row.from}</td>
                                        <td style={tdStyle}>{row.to}</td>
                                        <td style={tdStyle}>{row.discount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="subtitulo-politics">
                    <span>*All discounts must have prior authorization from the Commercial Management.</span><br /><br />
                    These discounts will be granted based on the monthly purchase history. A quarterly review of the billed amount will be held to make decisions on increasing or decreasing them.
                </div>

                <div className="subtitulo-politics">
                    <span>6. Promissory Note</span><br /><br />
                    For credit authorization, a promissory note must be signed, as well as the authorization document for consultation with the Credit Bureau.
                </div>


                <div className="subtitulo-politics">
                    <span>7. Minimum purchase and shipping</span><br /><br />
                    The minimum purchase will be $1,500.00 + IVA MXN with a shipping cost of $200.00 + IVA MXN. The minimum order amount
                    to be eligible for free shipping will be $3,500.00 + IVA MXN
                </div>

                <div className="subtitulo-politics">
                    <span>8. Documents and Data for registration</span><br /><br />
                    <ul>
                        <span>Documents</span><br />

                        <li>Deed of Incorporation (in case of being a legal entity), official identification on both sides of the legal representative,
                            updated tax status certificate, proof of fiscal address no older than three months, commercial policy
                            signed by the legal representative.
                        </li>

                        <span>Data</span><br />

                        <li> Name of the company whether a physical or legal entity, use of CFDI, contact phone number, contact name(s),
                            delivery address</li></ul>
                </div>

                <div className="subtitulo-politics">
                    <span>9. Payment methods:</span><br /><br />
                    All invoices must be paid via electronic transfer or deposit at a bank teller to our account, <b>no cash or checks are
                        accepted</b>. Likewise, it is <b>essential and rigorous</b> that the reference number of the transfer or deposit includes the <b>invoice or order number</b>
                    to which the transaction refers. If this reference is not included, Shimano Mexico will not be able to associate the payment with an invoice or order and it will not be able to be identified.
                </div>

                <div className="subtitulo-politics">
                    <span>10. Billing</span><br /><br />
                    Shimano Mexico does not guarantee that orders entered or paid for (in the case of cash orders which must be paid in advance prior to their billing and shipping) will be billed within the same current month.
                    Logically, we will always try to bill and ship orders within the same month they are received, however,
                    in the <b>last 3 days of the month</b> due to the volume of orders we do not guarantee this will always be possible.
                </div>

                <div className="subtitulo-politics">
                    <span>11. Exclusivity on distribution:</span><br /><br />
                    Shimano Mexico does not guarantee exclusivity in the distribution of products by zone that are acquired directly from the
                    brand at the moment they are registered with the company.
                </div>

                <div className="subtitulo-politics" style={{ fontWeight: 'bold' }}>
                    All clients must know their commercial conditions in writing. Therefore, it is necessary that all our
                    clients understand and sign the commercial policies.
                </div>
            </section>
        </>
    );
}

const thStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    textAlign: 'center',
};

const tdStyle = {
    border: '1px solid #ccc',
    padding: '10px',
    textAlign: 'center',
};
export default PoliticsComercialBikeUS;